
import FindPartner from "../../components/landing/searсh-on-live-sex-camstreams/find-partner";
import QuotesBlock from "../../components/landing/searсh-on-live-sex-camstreams/quotes-block";
import blog from "../../components/landing/blog";
import ServiceFor from "../../components/landing/searсh-on-live-sex-camstreams/service-for";
import HowWeDo from "../../components/landing/searсh-on-live-sex-camstreams/how-we-do";
import SitesScan from "../../components/landing/searсh-on-live-sex-camstreams/sites-scan";
import Waiting from "../../components/landing/searсh-on-live-sex-camstreams/waiting";
import Results from "../../components/landing/searсh-on-live-sex-camstreams/results";
import Steps from "../../components/landing/searсh-on-live-sex-camstreams/steps";
import RealStories from "../../components/landing/searсh-on-live-sex-camstreams/real-stories.vue";
import Featured from "../../components/landing/searсh-on-live-sex-camstreams/featured";
import Mission from "../../components/landing/searсh-on-live-sex-camstreams/mission";
import AlreadyUsing from "../../components/landing/searсh-on-live-sex-camstreams/already-using";
import Comments from "../../components/landing/searсh-on-live-sex-camstreams/comments.vue";
import Overcoming from "../../components/landing/searсh-on-live-sex-camstreams/overcoming";
import Faq from "../../components/landing/searсh-on-live-sex-camstreams/faq";
import QuotesBlockKnowledge from "../../components/landing/searсh-on-live-sex-camstreams/quotes-block-knowledge";
import Navigation from '../../components/Navigation.vue';
import FooterMain from '../../components/FooterMain.vue';

import isMob from "@/mixins/isMob";
import authorization from "@/mixins/authorization";

export default {
  mixins: [isMob, authorization],
  mounted() {
    this.getUtm()
  },
  components: {
    FindPartner,
    QuotesBlock,
    ServiceFor,
    blog,
    HowWeDo,
    SitesScan,
    Waiting,
    Results,
    Steps,
    RealStories,
    Featured,
    Mission,
    AlreadyUsing,
    Comments,
    Overcoming,
    Faq,
    QuotesBlockKnowledge,
    Navigation,
    FooterMain,
  },
  head() {
    const title = 'Catch Cheating Partner - Live Adult Stream Monitoring | Live Wife Webcams';
    const description = 'Check out the best cheater lookup websites. Find out if your partner is subscribed to live adult streams. Monitor their activities over time with iFindCheaters. Take action and check libve wife webcams.';

    return {
      title: title,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        { hid:'og:title', property: 'og:title', content: title },
        { hid: "description", name: "description", content: description },
        { hid: "og:description", name: "og:description", content: description },
        { hid: 'og:image',  property: 'og:image', content: '/products/find-someone-cheating-online-for-free/og.png' },
        { hid: 'twitter:title', name: 'twitter:title', content: title },
        { hid:'og:site_name', property: 'og:site_name', content: 'ifindcheaters.com' },
        { hid: 'og:keywords', name: 'og:keywords', content: 'secret profile finder, search people on dating sites, search for someone on dating sites, search dating profiles, is my husband on dating sites, find hidden dating profiles, find my wife on dating sites, catch a cheating spouse, find spouse on dating sites, Catch cheating partner online, Online infidelity search, find out if my boyfriend or girlfriend is on dating sites, how to find spouse on dating sites, is my wife on dating sites or apps, free dating profiles search by email' }
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/products/search-on-live-adult-streams/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Products",
              "item": "https://ifindcheaters.com/products/"
            },{
              "@type": "ListItem",
              "position": 3,
              "name": "Find your spouse on live webcam sites"
            }]
          }
        },{
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": "Find your spouse on live webcam sites ",
            "sku": "005",
            "image": "https://ifindcheaters.com/img/logo.png",
            "description": description,
            "brand": {
              "@type": "Brand",
              "name": "iFindCheaters"
            },
              "offers": {
              "@type": "Offer",
              "url": "https://ifindcheaters.com/products/search-on-live-adult-streams/",
              "priceCurrency": "USD",
              "price": "14.99",
              "priceValidUntil": "2022-05-25",
              "itemCondition": "https://schema.org/UsedCondition",
              "availability": "https://schema.org/InStock",
              "seller": {
              "@type": "Organization",
              "name": "iFindCheaters"
              }},
              "review": [{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Margarite C."
              },
              "datePublished": "2021-07-07T19:08:30+00:00",
              "reviewBody": "He wouldn’t tell me why our bank balance was so low. I can understand porn occasionally, but he was binge watching live adult streams! Talk about throwing money away, I stopped that nonsense."
            },{
              "@type": "Review",
              "reviewRating": {
                "@type": "Rating",
                "ratingValue": "4.5",
                "bestRating": "5"
              },
              "author": {
                "@type": "Person",
                "name": "Maddie F."
              },
            "datePublished": "2020-11-12T14:35:29+00:00",
            "reviewBody": "I did a search by name on Tinder and saw he was using the nickname I had given him as his Tinder username! Glad to let that one go."
            }],
              "aggregateRating": {
              "@type": "AggregateRating",
              "bestRating": "5",
              "ratingValue": "4.6",
              "reviewCount": "82"
              }
            }
          }
      ]
    }
  },

};
